export default __webpack_public_path__ + "static/media/01.4960aba2.jpg";